import { Button, Grid, Typography } from "@material-ui/core";
import { Tune } from "@material-ui/icons";
import { memo } from "react";
import HeaderModule from "../../../components/header/HeaderModule";

const DashboardHeaderModule = ({ action }) => {
  return (
    <HeaderModule
      title="DASHBOARD FINANCEIRO"
      receivedChild={
        <>
          <Grid item>
            <Button
              size="small"
              startIcon={<Tune />}
              color="primary"
              variant="contained"
              onClick={action}
            >
              Filtros gerais
            </Button>
          </Grid>
        </>
      }
    />
  );
};

export default memo(DashboardHeaderModule);
